import { Modal } from '@mui/material'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { modalSelector, setOpenPaymentModal } from '../../../redux/slices/modal'
import ButtonCloseModal from '../Buttons/ButtonCloseModal'
// import ButtonPay from '../Buttons/ButtonPay'
import ApplePayButton from '../Payment/ApplePayButton'
import GooglePayButton from '../Payment/GooglePayButton'

const PaymentModal = ({ title = '', subtitle = '', className = '' }) => {
  const { openPaymentModal } = useSelector(modalSelector)
  // const btnPayDisabled = false
  const dispatch = useDispatch()
  const handleClose = () => dispatch(setOpenPaymentModal(false))

  // const handlePay = () => {
  //   console.log('ipay payment')
  // }

  return (
    <Modal
      className={classNames(className, 'payment_modal modal_wrapper')}
      open={openPaymentModal}
      onClose={handleClose}
    >
      <div className="modal_component">
        <ButtonCloseModal handler={handleClose} />

        <div className="top_block">
          <span className="modal_title">{title || 'Оплата'}</span>
          <span className="modal_subtitle">
            {subtitle || 'Заповніть форму або оберіть платіжну систему'}
          </span>
          {/* <ButtonPay handler={handlePay} disabled={btnPayDisabled} /> */}
        </div>
        <div className="bottom_block">
          {/* <span className="modal_subtitle">або</span> */}
          <div className="payment_buttons">
            <ApplePayButton />
            <GooglePayButton />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PaymentModal
